module.exports = __webpack_public_path__ + "static/media/DOUBLE-BREASTED 6 BUTTONS.8aadf631.svg";